/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxAlternativesGetListOrder = typeof UtxAlternativesGetListOrder[keyof typeof UtxAlternativesGetListOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxAlternativesGetListOrder = {
  DESC: 'DESC',
  ASC: 'ASC',
} as const;
